export default {
  chatSession: {},
  messages: [],
};
